import { useEffect } from 'react';
import { useSEO } from '../../utils/seo';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import DataVisualization from './components/DataVisualization';
import Analytics from './components/Analytics';
import Integration from './components/Integration';
import Security from './components/Security';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import CTA from './components/CTA';
import Footer from './components/Footer';

export default function HomePage() {
  useSEO({
    title: 'ProtectWize | Advanced Data Analytics & Business Intelligence Platform',
    description: 'Transform your business with ProtectWize\'s powerful data analytics platform. Real-time insights, AI-powered analytics, enterprise security, and seamless integration. Start your free trial today.',
    keywords: 'data analytics, business intelligence, AI analytics, real-time insights, enterprise security, data visualization',
    canonical: `${import.meta.env.VITE_SITE_URL}/`,
    ogType: 'website',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'ProtectWize',
      url: import.meta.env.VITE_SITE_URL,
      logo: `${import.meta.env.VITE_SITE_URL}/logo.png`,
      description: 'Advanced Data Analytics & Business Intelligence Platform providing real-time insights, AI-powered analytics, and enterprise-grade security.',
      sameAs: [
        'https://www.linkedin.com/company/protectwize',
        'https://twitter.com/protectwize',
        'https://www.facebook.com/protectwize'
      ],
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+1-555-0123',
        contactType: 'customer service',
        areaServed: 'US',
        availableLanguage: ['en']
      },
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'US'
      }
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Features />
      <DataVisualization />
      <Analytics />
      <Integration />
      <Security />
      <Testimonials />
      <Pricing />
      <CTA />
      <Footer />
    </div>
  );
}